export class AppStatusViewModel {
  isLoading: boolean;
  message: string;

  constructor(isLoading: boolean, message: string) {
    this.isLoading = isLoading;
    this.message = message;
  }
}
